var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8546 48.5477V24.9609H10V80.714C10 84.5687 13.1253 87.694 16.9801 87.694H77.1742L86.4315 96.8554L93.2371 90.2243L90.5096 87.5004C93.5756 86.7657 95.8546 84.0051 95.8546 80.714V63.9619V48.5477Z",
    fill: "#DFEDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8546 48.5477V24.9609H10V80.714C10 84.5687 13.1253 87.694 16.9801 87.694H77.1743L86.4315 96.8554L93.2371 90.2243L90.5096 87.5004C93.5756 86.7657 95.8546 84.0051 95.8546 80.714V63.9619",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8544 58.0506C96.8181 58.0506 97.5994 57.2693 97.5994 56.3056C97.5994 55.3418 96.8181 54.5605 95.8544 54.5605C94.8906 54.5605 94.1094 55.3418 94.1094 56.3056C94.1094 57.2693 94.8906 58.0506 95.8544 58.0506Z",
    fill: "#201F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8546 24.9601H10V17.9801C10 14.1251 13.1251 11 16.9801 11H88.8746C92.7295 11 95.8546 14.1251 95.8546 17.9801V24.9601Z",
    fill: "#A0C8FF",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7266 17.9805H34.4317",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4238 17.9805H87.1289",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9294 80.7125C66.1809 80.7125 76.9233 69.97 76.9233 56.7186C76.9233 43.4671 66.1809 32.7246 52.9294 32.7246C39.6779 32.7246 28.9355 43.4671 28.9355 56.7186C28.9355 69.97 39.6779 80.7125 52.9294 80.7125Z",
    fill: "#FAF7F5",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.928 73.7329C62.3245 73.7329 69.9419 66.1155 69.9419 56.719C69.9419 47.3225 62.3245 39.7051 52.928 39.7051C43.5315 39.7051 35.9141 47.3225 35.9141 56.719C35.9141 66.1155 43.5315 73.7329 52.928 73.7329Z",
    fill: "#FCAC62",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7156 63.5067L46.1426 49.9336",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7156 49.9336L46.1426 63.5067",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3987 76.2532L72.4621 81.1899L67.248 75.9758C69.1221 74.578 70.7869 72.9133 72.1847 71.0391L77.3987 76.2532Z",
    fill: "#FAF7F5",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2381 90.2235L86.4325 96.8546L71.5371 82.1145L78.3235 75.3281L93.2381 90.2235Z",
    fill: "#FCAC62",
    stroke: "#201F1F",
    strokeWidth: 3.49002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoData);
export default __webpack_public_path__ + "static/media/ic-no-data.155a45f124f1adcdad6959bf483fb149.svg";
export { ForwardRef as ReactComponent };